import request from '@/utils/request'

export function getInviteCode() {
  return request({
    url: '/api/user/invite-code',
    method: 'get'
  })
}

export function getInviteRecords(data) {
  return request({
    url: '/api/user/invite-records',
    method: 'get',
    params: data
  })
}

export function getInviteInfoByCode(inviteCode) {
  return request({
    url: '/api/user/invite-info',
    method: 'post',
    data: {
      invite_code: inviteCode
    }
  })
}

export function getInviteBindStatus() {
  return request({
    url: '/api/user/invite-bindstatus',
    method: 'get'
  })
}

export function bindInviteCode(inviteCode) {
  return request({
    url: '/api/user/bind-invite-code',
    method: 'post',
    data: {
      invite_code: inviteCode
    }
  })
}
